import { h } from "@stencil/core";
import { getSoftwareModulesByType } from "../../../api/publicApi/software";
import { PrefillData } from "../../../api/publicApi/createCase";
import { FormStore } from "./form-store";
import { ApiStore } from "../api-store";
import { TranslationKey } from "../../../utils/loadTranslations";
import { classifications } from "../../../api/classifications";

interface SoftwareModuleSelectProps {
    t: (key: string) => string;
    prefillData: PrefillData | null;
    formStore: FormStore;
    apiStore: ApiStore;
}
interface CheckboxProps {
    t: (key: string) => string;
    prefillData: PrefillData | null;
}

export const SoftwareModuleSelect = ({ t, prefillData, formStore, apiStore }: SoftwareModuleSelectProps) => (
    <ux-select
        required
        label={t("field.softwareModule.label")}
        data-validation-required--msg={t("validation.requiredField")}
        name="softwareModule"
        disabled={prefillData?.softwareData.softwareModule}
    >
        <option value="" selected={!prefillData?.softwareData.softwareModule} disabled>
            {t("select.placeholder")}
        </option>
        {getSoftwareModulesByType(apiStore.state.softwares, formStore.state.selectedSoftwareType as string).map(
            (softwareModule) => (
                <option value={softwareModule} selected={softwareModule === prefillData?.softwareData.softwareModule}>
                    {t(`softwareModule.${softwareModule}` as TranslationKey)}
                </option>
            )
        )}
    </ux-select>
);

export const SoftwareTypeSelect = ({ t, prefillData, formStore, apiStore }: SoftwareModuleSelectProps) => (
    <ux-select
        required
        label={t("field.softwareType.label")}
        name="softwareType"
        onUxChange={(event) => {
            formStore.state.selectedSoftwareType = event.detail.value;
        }}
        disabled={prefillData?.softwareData.softwareType}
    >
        <option value="" selected={!prefillData?.softwareData.softwareType} disabled>
            {t("select.placeholder")}
        </option>
        {apiStore.state.softwareTypes.map((softwareType) => (
            <option value={softwareType} selected={prefillData?.softwareData.softwareType === softwareType}>
                {softwareType}
            </option>
        ))}
    </ux-select>
);

export const SoftwareClassificationSelect = ({ t, prefillData }: CheckboxProps) => {
    const hasPrefilledClassification = classifications.includes(prefillData?.softwareData.softwareProblemClassification as string);
    return (
        <ux-select
            required
            label={t("field.softwareProblemClassification.label")}
            data-validation-required--msg={t("validation.requiredField")}
            name="softwareProblemClassification"
        >
            <option value="" selected={!hasPrefilledClassification} disabled>
                {t("select.placeholder")}
            </option>
            {classifications.map((classification) => (
                <option
                    value={classification}
                    selected={classification === prefillData?.softwareData.softwareProblemClassification}
                >
                    {t(`softwareProblemClassification.${classification}` as TranslationKey)}
                </option>
            ))}
        </ux-select>
    );
};
export const InstallationCheckbox = ({ t, prefillData }: CheckboxProps) => (
    <ux-checkbox
        label={t("field.softwareInstallationProblem.label")}
        name="installationProblem"
        checked={prefillData?.softwareData.isInstallationProblem}
        disabled={typeof prefillData?.softwareData.isInstallationProblem === "boolean"}
    ></ux-checkbox>
);

export const LicenseCheckbox = ({ t, prefillData }: CheckboxProps) => (
    <ux-checkbox
        label={t("field.softwareLicenseIssue.label")}
        name="licenseIssue"
        checked={prefillData?.softwareData.isLicenseIssue}
        disabled={typeof prefillData?.softwareData.isLicenseIssue === "boolean"}
    ></ux-checkbox>
);
